import $ from "jquery";
import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import Comm from "../comm/comm";
import Context from "../context/context";
import Translation from "../translation/translation";

class InOut extends Component {
    constructor(props) {
        super(props);
        if (!Comm.ValidSession()) return;

        var sid = Context.GetContext().Sid;
        var allarticles = Comm.Articles(sid, true);
        var iod = Comm.GetInOut({ session: sid });
        var permissions = Comm.Permissions(sid);

        var articles = [];
        for (var iter = 0; iter < allarticles.length; iter++) {
            var a = allarticles[iter];
            articles.push(a);
        }

        this.state = {
            AllArticles: allarticles,
            Articles: articles,
            Iod: iod,
            Permissions: permissions,
            SelectedArticle: null,
        };

        this.Save = this.Save.bind(this);
    }

    ShowArticle(article) {
        this.setState({ SelectedArticle: article });
    }

    Save() {
        var sid = Context.GetContext().Sid;

        var outs = [];
        $("input[id^='cbArticle']:checked").each(function (i, e) {
            var val = $(e).attr("permvalue");
            outs.push({ id: val });
        });
        var data = {
            session: sid,
            articles: JSON.stringify({ id: this.state.SelectedArticle.id, out: outs }),
        };
        Comm.SaveInOut(data);

        this.setState({
            Iod: Comm.GetInOut({ session: sid }),
            SelectedArticle: null,
        });
    }

    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return <Redirect to="/login" push></Redirect>;
        }

        if (Context.RenderNotOK(this.props.history)) return null;

        return Context.HasRight("rinout") === true ? (
            <div className="panel panel-default">
                <div className="panel-heading">{Translation.Trans("inputoutputgoods")}</div>
                <div className="panel-body">
                    <br />
                    <div className="row">
                        <div className="col-md-5">
                            {this.state.Iod.map((obj) => (
                                <p
                                    className={
                                        this.state.SelectedArticle != null &&
                                        this.state.SelectedArticle.id === obj.id
                                            ? "btn btn-warning"
                                            : null
                                    }
                                >
                                    <a onClick={() => this.ShowArticle(obj)} className="pointhand">
                                        {obj.name}
                                    </a>
                                </p>
                            ))}
                        </div>
                        <div className="col-md-7">
                            {this.state.SelectedArticle !== null ? (
                                <div id="dData" className="borderDiv">
                                    <div className="row">
                                        <div className="col-md-12">
                                            {Context.HasRight("einout") === true ? (
                                                <button
                                                    className="btn btn-primary pull-right"
                                                    onClick={this.Save}
                                                >
                                                    {Translation.Trans("save")}
                                                </button>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div className="row scrollableDiv">
                                        <div className="col-md-6">
                                            {this.state.Articles.map((obj) => (
                                                <div className="checkbox">
                                                    <input
                                                        id={"cbArticle" + obj.id}
                                                        type="checkbox"
                                                        permvalue={obj.id}
                                                        key={obj.id + "_" + this.state.SelectedArticle.id}
                                                        defaultChecked={this.state.SelectedArticle.hasOwnProperty(
                                                            "o" + obj.id
                                                        )}
                                                    />
                                                    <label for={"cbArticle" + obj.id}>{obj.name}</label>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        ) : (
            <div>{Translation.Trans("noRights")}</div>
        );
    }
}

export default InOut;



// WEBPACK FOOTER //
// ./src/pages/inout.js